import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../images/shine_header_logo.png";
import whatsApp from "../images/hireDeveloper/WhatsApp.svg";
import pirotan from "../images/home/client/pirotan.png";
import pirotan_logo from "../images/pirotan_logo.png";
import sauratech from "../images/home/client/sauratech.png";
import cybersiara from "../images/home/client/cybersiara.svg";

const Footer = () => {
  const [scroll, setScroll] = useState(false);
  const location = useLocation();

  const handleclick = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 10);
    });
  }, [location.pathname]);

  // Tawk.to integration
  useEffect(() => {
    // Check if Tawk.to script is already loaded
    if (!window.Tawk_API) {
      window.Tawk_API = window.Tawk_API || {};
      window.Tawk_LoadStart = new Date();

      const script = document.createElement("script");
      script.async = true;
      script.src = "https://embed.tawk.to/68d3a5eb2528731922c419c7/1j5tc08lu";
      script.charset = "UTF-8";
      script.setAttribute("crossorigin", "*");

      const firstScript = document.getElementsByTagName("script")[0];
      firstScript.parentNode.insertBefore(script, firstScript);
    }
  }, []);

  // Google tag (gtag.js) integration
  useEffect(() => {
    // Check if Google tag script is already loaded
    if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
      // Initialize dataLayer and gtag function
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function() {
        window.dataLayer.push(arguments);
      };
      window.gtag('js', new Date());
      window.gtag('config', 'AW-986392931');

      // Load the Google tag script
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://www.googletagmanager.com/gtag/js?id=AW-986392931";
      
      const firstScript = document.getElementsByTagName("script")[0];
      firstScript.parentNode.insertBefore(script, firstScript);
    }
  }, []);

  return (
    <>
      <section className="footerSection">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-9 col-lg-8 col-md-8 col-sm-4">
              <div className="ft-logo">
                <img src={Logo} alt="hire dedicated developer" />
              </div>
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-5 ml-auto">
              <div className="menu">
                <ul>
                  <li>
                    <Link to="/HireDeveloper">Hire Developer</Link>
                  </li>
                  {/* <li><Link to='/GetHire'>Get hired</Link></li> */}
                  <li>
                    <Link to="/ContactUs">Contact us</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-12 pl-0 pr-0">
              <hr />
            </div>

            <div className="col-md-12 infoBG">
              <div className="row align-items-center">
                <div className="col-lg-6 col-md-6 mb-5 mb-md-0">
                  <div className="businessPartner">
                    <p>Business Partner</p>
                    <div className="images">
                      <a href="https://www.pirotan.com/" target="_blank">
                        <img src={pirotan_logo} />
                      </a>
                      {/* <a href="https://sauratech.com/" target="_blank">
                        <img src={sauratech} />
                      </a>  */}
                      <a href="https://www.cybersiara.com/" target="_blank">
                        <img src={cybersiara} />
                      </a>
                    </div>
                  </div>
                </div>

                <div className="col-lg-5 col-md-6 mb-4 mb-md-0 ml-auto">
                  <div className="information">
                    <ul>
                      <li>
                        <div className="icon">
                          <i className="fa-solid fa-location-dot"></i>
                        </div>
                        {/* <a
                          href="https://www.google.com/maps/search/?api=1&query=ShineInfosoft"
                          target="_blank"
                        > */}
                          971, US Highway 202 N, Ster Somerset County,
                          Branchburg, NJ 08876, US
                        {/* </a> */}
                      </li>
                    </ul>
                    <ul className="d-md-flex justify-content-between">
                      <li>
                        <div className="icon">
                          <i className="fa fa-envelope"></i>
                        </div>
                        <a href="mailto:info@shineinfosoft.us">
                          info@shineinfosoft.us
                        </a>
                      </li>
                      <li>
                        <div className="icon">
                          <i className="fa fa-phone"></i>
                        </div>
                        <a href="tel:+12013836765">+1 201 383 6765</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12 pl-0 pr-0">
              <hr />
            </div>

            <div className="col-md-6 mb-4 mb-md-0">
              <div className="copyright">
                <p>
                  Copyright &copy; {new Date().getFullYear()}{" "}
                  <a href="/">Shine Infosoft</a> | All Rights Reserved.
                </p>
              </div>
            </div>

            <div className="col-md-6 text-right">
              <div className="social">
                <ul>
                  {/* <li>
                    <a
                      href="https://www.facebook.com/shineinfosoft.in/"
                      target="_blank"
                    >
                      <i className="fa-brands fa-facebook-f"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://x.com/shine_infosoft" target="_blank">
                      <i className="fa-brands fa-x-twitter"></i>
                    </a>
                  </li> */}
                  <li>
                    <a
                      href="https://www.linkedin.com/company/shine-infosoft/"
                      target="_blank"
                    >
                      <i className="fa-brands fa-linkedin"></i>
                    </a>
                  </li>
                  {/* <li>
                    <a
                      href="https://www.instagram.com/shineinfosoft/"
                      target="_blank"
                    >
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://in.pinterest.com/shineinfosoftllc/"
                      target="_blank"
                    >
                      <i className="fa-brands fa-pinterest-p"></i>
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <a
        className="whatsApp"
        href="https://wa.me/+917990440723"
        target="_blank"
        style={{
          position: "fixed",
          left: "20px",
          right: "auto",
          bottom: "20px",
          zIndex: 9999,
        }}
      >
        <img src={whatsApp} alt="hire react native developer" />
      </a>
      <a
        className={`arrowUp ${scroll ? "d-flex" : "d-none"}`}
        onClick={handleclick}
      >
        <i className="fa fa-angle-up"></i>
      </a>
    </>
  );
};


export default Footer;
